export const url = "";
export const REACT_APP_BASE_URL = "/";
// export const REACT_APP_API_BASE_URL = "http://localhost:3000/api/admin/";
// export const REACT_APP_API_BASE_URL = "https://horsely-api-qa.dev9server.com/api/admin/" // Qa
// export const REACT_APP_API_BASE_URL = "https://demo.dev9server.com:3056/api/admin/" // Stagging
// export const REACT_APP_API_BASE_URL =
//   "https://demo.dev9server.com:3057/api/admin/"; // Dev

  export const REACT_APP_API_BASE_URL =
  "https://stg-api.treatyourself-ks.com/api/admin/"; // Stage

// export const REACT_APP_API_BASE_URL = "https://api.treatyourself-ks.com/api/admin/"; // live
// export const REACT_APP_API_BASE_URL = "https://horsely-api-stg.dev9server.com/api/admin/"  // Stg

// export const REACT_APP_API_BASE_URL = "http://localhost:3002/api/admin/"; // ad local
// export const REACT_APP_API_BASE_URL = "http://192.168.1.20:3002/api/admin/"

export const APP_NAME = "TreatYourself";
export const APP_DEVELOPED_BY = "NineHertz";
export const PORT = "3000";

export const MAP_API_KEY = "AIzaSyA9SVcFjXtuatMWdVE2Es_k4xR8JwnIjxM";
// export const MAP_API_KEY = 'AIzaSyBjzz7QQk2sPlc7_GxgW8fRS4IFXM4J5as'
// Subpath deploy (e.g. demo): set BASE_URL and BrowserRouter basename to match, e.g. "/fely-beauty-admin-dev"
export const BASE_URL = "";
